import { useState } from "react";
import { cn } from "@/lib/cn";
import { ContasAPagar } from "./ContasAPagar";
import { CustosFixos } from "./CustosFixos";

export function APagar({ competencia }: { competencia: string }) {
  const [parte, setParte] = useState<"contas" | "fixos">("contas");
  return (
    <div className="space-y-4">
      <div className="inline-grid grid-cols-2 gap-1 rounded-lg bg-zinc-100 p-1 dark:bg-muted">
        {(
          [
            { chave: "contas", rotulo: "Contas" },
            { chave: "fixos", rotulo: "Custos fixos" },
          ] as const
        ).map((p) => (
          <button
            key={p.chave}
            type="button"
            onClick={() => setParte(p.chave)}
            className={cn(
              "rounded-md px-4 py-1.5 text-sm font-semibold",
              parte === p.chave ? "bg-white text-zinc-900 shadow-sm dark:bg-card dark:text-foreground" : "text-zinc-500 dark:text-muted-foreground",
            )}
          >
            {p.rotulo}
          </button>
        ))}
      </div>
      {parte === "contas" ? <ContasAPagar competencia={competencia} /> : <CustosFixos />}
    </div>
  );
}
